module.exports = __webpack_public_path__ + "static/img/LU@3x.9136f530.jpg";